enum WebservicePdfaFields {
	ENABLED = "pdfa_enabled",
	INSTANCES = "pdfa_instances",
	QUEUE = "pdfa_queue",
	LATENCY = "pdfa_latency",
	FONTPATH = "pdfa_fontpath",
}

export default WebservicePdfaFields;